import React from 'react';

interface TooltipProps {
  text: string;
  children: React.ReactElement;
  position?: 'top' | 'bottom';
  variant?: 'dark' | 'light-blue';
  align?: 'center' | 'right' | 'left';
  /** Compact tooltips have no min-width and use nowrap — for icon-button toolbars in narrow containers. */
  compact?: boolean;
}

const variantClasses = {
  dark: 'bg-gray-900 dark:bg-medical-700 text-white',
  'light-blue': 'bg-yellow-50 dark:bg-yellow-900/40 text-yellow-900 dark:text-yellow-100 border border-yellow-300 dark:border-yellow-700 font-semibold',
};

const alignClasses = {
  center: 'left-1/2 -translate-x-1/2',
  right: 'right-0',
  left: 'left-0',
};

export const Tooltip: React.FC<TooltipProps> = ({ text, children, position = 'bottom', variant = 'dark', align = 'center', compact = false }) => {
  const sizeClasses = compact ? 'whitespace-nowrap' : 'min-w-[280px] max-w-sm';
  return (
    <div className={`relative group/tip ${compact ? 'inline-flex' : ''}`}>
      {children}
      <div className={`absolute ${alignClasses[align]} z-50 pointer-events-none opacity-0 group-hover/tip:opacity-100 transition-opacity duration-150 ${
        position === 'top' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'
      }`}>
        <div className={`${variantClasses[variant]} text-[11px] leading-tight rounded-md px-2.5 py-1.5 shadow-lg ${sizeClasses}`}>
          {text}
        </div>
      </div>
    </div>
  );
};
